<template>
  <div v-if="options && !disabled" class="form-floating" :class="'mb-'+mb">
    <select
        class="form-select form-select-solid"
        :aria-label="placeholder"
        :disabled="disabled"
        :value="modelValue"
        :required="required"
        :name="name"
        :id="id"
        @input="updateValue"
    >
      <option
          v-for="(item, key) in options"
          v-html="item"
          :selected="modelValue === key"
          :value="key"
          :key="key"
      ></option>
    </select>
    <label :for="id" :class="{ required: required }" v-html="placeholder"></label>
  </div>
  <disabled-field v-else :value="options[modelValue]" :mb="mb" :placeholder="placeholder" :required="required"/>
</template>

<script>
import DisabledField from '@/components/Fields/DisabledField'

export default {
  name: 'SelectField',
  components: {DisabledField},
  props: {
    combination: null,
    placeholder: null,
    modelValue: null,
    required: false,
    disabled: null,
    options: null,
    name: null,
    id: null,
    mb:null
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', parseInt(event.target.value))
    }
  }
}
</script>

<style scoped>

</style>